import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule } from '../shared/components/components.module';

import { MainRoutingModule } from './main-routing.module';

import { MainComponent } from './main.component';
import { TooltipComponent } from './tooltip/tooltip.component';


@NgModule({
  declarations: [
    MainComponent,
    TooltipComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    MainRoutingModule,
  ],
  providers: [
  ],
  exports: [
    MainComponent,
  ],
})
export class MainModule {}
